import { GetBy } from "../_app/cuchillo/core/Element";
import { Basics, isDebug } from '../_app/cuchillo/core/Basics';
import { Maths } from "../_app/cuchillo/utils/Maths";
import { Sizes } from "../_app/cuchillo/core/Sizes";

import gsap from "gsap";
import Background from "../components/Background";
import Header from "./Header";

export default class Preloader {
    _container;
    icon;

    static init() {
        this._container = GetBy.id('Preloader');
        this.icon = GetBy.class('icon', this._container)[0];
        gsap.set(this.icon, { opacity: 0 });

        // if (isDebug) this._container.style.display = "none";
    }

    static update(__progress) {
        if (isDebug) return;
    }

    static hide(__call) {
        // if (isDebug) {
        //     Background.show();
        //     this._container.style.display = "none";
        //     if (__call) __call();
        //     return;
        // }

        gsap.to(this.icon, { opacity: 1, duration: .3, delay: .5 });
        gsap.to(this._container, { opacity: 0, duration: .3, delay: 1.5 });
        gsap.delayedCall(1.75, () => {
            Background.show(() => {
                this._container.style.display = "none";
                if (__call) __call();
            })
        })
    }
}
